import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import CenteredLoading from "./shared_components/CenteredLoading/CenteredLoading";
import { aipTheme } from "./styles";
import { msalInstance } from "./utils/msal.util";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

const LoadingComponent = () => <CenteredLoading />;

createRoot(document.getElementsByTagName("app")[0]!).render(
  <StrictMode>
    <ThemeProvider theme={aipTheme}>
      <QueryClientProvider client={queryClient}>
        <MsalProvider instance={msalInstance}>
          <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            errorComponent={(props) => <p>{JSON.stringify(props)}</p>}
            loadingComponent={LoadingComponent}
          >
            <App />
          </MsalAuthenticationTemplate>
        </MsalProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
